import {Button, Card, Checkbox, DatePicker, Select, Switch, TimePicker, Popconfirm, Input } from "antd";
import "./styles.css";
import { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  getSettingsAutomaticActions,
  updateSettingsAutomaticActions,
  setDatapointPending
} from "../../../store/actions/settings.actions";
import { useSelector } from "react-redux";
import { SaveOutlined } from "@ant-design/icons";
import { LoadingComponent } from "../../Common/LoadingComponent";
import { useAuth0 } from "@auth0/auth0-react";
import { TrainingAPI } from "../../../api/TrainingAPI"
import { audioMessage as message } from "../../Common/Notifications/audioMessage";


const TRIGGERS = [
  {
    key: "WellnessNotify",
    label: "Wellness Survey Notification",
    comingSoon: false,
    hasEmailList: false
  },
  {
    key: "WellnessReport",
    label: "Wellness Report",
    comingSoon: false,
    hasEmailList: true
  },
  {
    key: "DailyReport",
    label: "Daily Report",
    comingSoon: false,
    hasEmailList: true
  },
  {
    key: "WeeklyReport",
    label: "Weekly Report",
    comingSoon: false,
    validFrequencies: ['weekly'],
    hasEmailList: true
  },
  {
    key: "gpsReport",
    label: "GPS Report",
    comingSoon: true,
    hasEmailList: true
  },
  {
    key: "forceplateReport",
    label: "Forceplate Report",
    comingSoon: true,
    hasEmailList: true
  },
  {
    key: "testingReport",
    label: "Testing Report",
    comingSoon: true,
    hasEmailList: true
  },
];

const FREQUENCIES = [
  {
    key: "daily",
    label: "Reports Daily",
  },
  {
    key: "weekly",
    label: "Reports Weekly",
  },
];

const AVAILABLE_TRIGGERS = TRIGGERS.filter((trigger) => !trigger.comingSoon);

export const AutomaticActions = () => {
  const dispatch = useDispatch();
  const {
    automaticActions,
    loading: { automatic: loading },
    pending: { automatic: pending },
  } = useSelector(({ settings }) => settings);
  const { user } = useAuth0();
  const { sport, info: { coach_list: coachList } } = useSelector(({ team }) => team);
  const [dateTime, setDateTime] = useState(
    AVAILABLE_TRIGGERS.reduce(
      (acc, curr) => ({ ...acc, [curr.key]: moment() }),
      {}
    )
  );
  const [frequencies, setFrequencies] = useState(
    AVAILABLE_TRIGGERS.reduce(
      (acc, curr) => ({ ...acc, [curr.key]: "daily" }),
      {}
    )
  );
  const [temp_loading, set_temp_loading] = useState(false)
  const [opponents, set_opponents] = useState("Chelsea, Arsenal, West Ham, Liverpool")
  const [disable, setDisable] = useState(
    AVAILABLE_TRIGGERS.reduce((acc, curr) => ({ ...acc, [curr.key]: true }), {})
  );
  const [emailList, setEmailList] = useState(
      AVAILABLE_TRIGGERS.reduce((acc, curr) => ({ ...acc, [curr.key]: [] }), {})
  );

  useEffect(() => {
    dispatch(getSettingsAutomaticActions());
  }, []);

  useEffect(() => {
    if (
      automaticActions &&
      automaticActions.triggers &&
      automaticActions.triggers.length > 0
    ) {
      setDateTime({
        ...dateTime,
        ...automaticActions.triggers.reduce((acc, cur) => {
          acc[cur.action_type] =
            cur.frequency !== "none"
              ? moment(`${cur.day || ""} ${cur.time}`, "ddd HH:mm")
              : moment();
          return acc;
        }, {}),
      });
      setFrequencies({
        ...frequencies,
        ...automaticActions.triggers.reduce((acc, cur) => {
          acc[cur.action_type] =
            cur.frequency !== "none" ? cur.frequency : getValidFrequencies(cur.action_type)[0].key || FREQUENCIES[0].key;
          return acc;
        }, {}),
      });
      setDisable({
        ...disable,
        ...automaticActions.triggers.reduce((acc, cur) => {
          acc[cur.action_type] = cur.frequency === "none";
          return acc;
        }, {}),
      });
      setEmailList({
        ...emailList,
        ...automaticActions.triggers.reduce((acc, cur) => {
          acc[cur.action_type] = parseEmailList(cur.emails, cur.action_type) || [];
          return acc;
        }, {}),
      })
    }
  }, [automaticActions]);

  const handleUpdate = (dateTime, frequencies, disable, emailList) => {
    const triggers = Object.keys(dateTime).map((action_type) => ({
      day:
        disable[action_type] || frequencies[action_type] === "daily"
          ? null
          : dateTime[action_type]?.format("ddd").toUpperCase(),
      time: dateTime[action_type]?.format("HH:mm").toUpperCase(),
      frequency: disable[action_type] ? "none" : frequencies[action_type],
      action_type,
      emails: emailList[action_type] || [],
    }));
    dispatch(updateSettingsAutomaticActions({ triggers }));
  };

  const handleChangeDateTime = (key) => (value) => {
    setDateTime((prevDateTime) => ({ ...prevDateTime, [key]: value }));
  };

  const handleChangeFrequencies = (key) => (value) => {
    setFrequencies({ ...frequencies, [key]: value });
  };

  const handleChangeDisable = (key) => (value) => {
    setDisable((prevDisable) => {
      const newDisable = { ...prevDisable, [key]: !value };
      handleUpdate(dateTime, frequencies, newDisable, emailList);
      return newDisable;
    });
  };

  const renderTrigger = trigger => {
    if (trigger?.sports) {
      // render trigger only for sports defined per trigger
      return trigger.sports.includes(sport);
    }
    // if no 'sports' array defined, render for all teams
    return true;
  }

  const getValidFrequencies = key => {
    const trigger = TRIGGERS.find(t => t.key === key)
    if (trigger?.validFrequencies?.length) {
      return FREQUENCIES.filter(f => trigger.validFrequencies.includes(f.key))
    }
    return FREQUENCIES;
  }

  const handleChangeEmailList = (key) => (value) => {
    setEmailList((prevEmailList) => ({ ...prevEmailList, [key]: value }));
  };

  const handleSampleWeeklyReport = async () => {
    set_temp_loading(true)
    const trainingAPI = new TrainingAPI();
    const payload = {
      action: 'gen_dummy_weekly_report',
      opponents: opponents
    }
    await trainingAPI.performCustomAction(payload)
    .then(resp => {
      message.info(resp)
    }).catch(err => {
      console.log(err);
      message.error("Error")
    })
    set_temp_loading(false)

  }

  const parseEmailList = (emails, actionType) => {
    // process the email list just after querying
    // if trigger.emails is [], that actually means that emails go to all
    const trigger = TRIGGERS.find(t => t.key === actionType);
    if (trigger?.hasEmailList) {
      return emails?.length ? emails : coachList.map(coach => coach.email);
    } else {
      return [];
    }
  }

  return (
    <div style={{ width: 640, maxWidth: "100%" }}>
      <p className="automatic-actions-timezone-text">
        All times are set to Eastern Time (EST)
      </p>
      <LoadingComponent loading={loading}>
        <div className="automatic-actions-wrap">
          {TRIGGERS.filter(t => renderTrigger(t)).map((trigger) => (
            <Card className="automatic-actions-item-group">
              <div className="automatic-actions-item" key={trigger.key}>
                  <div className="automatic-actions-item-label">
                      {trigger.label}
                  </div>
                  <div className="automatic-actions-item-input">
                      {trigger.comingSoon ? (
                          <div>Coming Soon...</div>
                      ) : (
                          <>
                              <Select
                                  style={{ flex: 1 }}
                                  showSearch
                                  optionFilterProp="value"
                                  value={frequencies[trigger.key]}
                                  onChange={handleChangeFrequencies(trigger.key)}
                                  disabled={disable[trigger.key]}
                              >
                                  {getValidFrequencies(trigger.key).map((freq) => (
                                      <Select.Option value={freq.key} key={freq.key}>
                                          {freq.label}
                                      </Select.Option>
                                  ))}
                              </Select>
                              {frequencies[trigger.key] === "weekly" ? (
                                  <DatePicker
                                      style={{ flex: 1 }}
                                      format={"ddd HH:mm"}
                                      value={dateTime[trigger.key]}
                                      onChange={handleChangeDateTime(trigger.key)}
                                      showTime={{ use12Hours: false, format: "HH:mm" }}
                                      allowClear={false}
                                      disabled={disable[trigger.key]}
                                  />
                              ) : (
                                  <TimePicker
                                      style={{ flex: 1 }}
                                      format="HH:mm"
                                      use12Hours={false}
                                      value={dateTime[trigger.key]}
                                      onChange={handleChangeDateTime(trigger.key)}
                                      allowClear={false}
                                      disabled={disable[trigger.key]}
                                  />
                              )}
                              <Switch
                                  checked={!disable[trigger.key]}
                                  onChange={handleChangeDisable(trigger.key)}
                              />
                          </>
                      )}
                  </div>
              </div>
              {
                // render email list for active triggers (not disabled and not coming soon)
                (!disable[trigger.key] && !trigger.comingSoon && trigger.hasEmailList) && (
                  <div className="automatic-actions-collapsible-email-list">
                    <div className="automatic-actions-collapsible-email-list-label">
                      Email List
                    </div>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ flex: 3 }}
                      placeholder="Select emails"
                      showSearch
                      optionFilterProp="value"
                      value={emailList[trigger.key]}
                      onChange={handleChangeEmailList(trigger.key)}
                      disabled={disable[trigger.key]}
                    >
                        {coachList.map((coach) => (
                            <Select.Option key={coach.email} value={coach.email}>
                                {coach.email}
                            </Select.Option>
                        ))}
                    </Select>
                  </div>
                )
              }
            </Card>
          ))}
          <div className="automatic-actions-item">
            <Button
              loading={pending}
              onClick={() => handleUpdate(dateTime, frequencies, disable, emailList)}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              type="primary"
            >
              <SaveOutlined />
              Save Triggers
            </Button>
          </div>
          {
            user.email.endsWith("@gpsdataviz.com") && (
              <>
              <Popconfirm
                title={<>
                Generate a sample report? <br /><br />
                Opponents (Type 4): <Input
                  size="small"
                  placeholder="Basic usage"
                  value={opponents}
                  onChange={(e) => set_opponents(e.target.value)}
                />
                </>}
                okText="Yes"
                cancelText="No"
                onConfirm={handleSampleWeeklyReport}
                onCancel={null}
              >
              <Button
              loading={temp_loading}
              // onClick={handleSampleWeeklyReport}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              type="primary"
            >
              <SaveOutlined />
              Gen Sample Weekly Report with current Team Colors
            </Button>
            </Popconfirm>
              </>
            )
          }
        </div>
      </LoadingComponent>
    </div>
  );
};
